import { createContext, useContext } from 'react';

const CookieContext = createContext({});

export const useCookieContext = () => useContext(CookieContext);
